import { Component, ViewEncapsulation, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CustomerService, StorageService } from '../../_services/index';
import { DataService, OptionsserviceService, LoansService, OperationsService } from '../../_services/index';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-applicationspending',
  templateUrl: './applicationspending.component.html',
  styleUrls: ['./applicationspending.component.css', './style.css', './boot-outline-btn.css']
})
export class ApplicationspendingComponent implements OnInit {
  showPicture = false;
  currentUser: any;
  parentRouteId: any;
  sub: any;
  loan: any;
  creating_contract = false;
  customer: any;
  canDoApproval = false;
  approvals_queue: any;
  level: any;
  prev_levels: any;
  editing = '';
  public model_r = { ilo: 0, reject_reason: '', reject_action: '', approval_notes: '', reject_level: '', wtd: 0, request_id: '', level: '' };
  public model_a = { chk_acts: [], past_one: 1, approval_all_waivers: 1, approval_all_checklist: 1, is_waiver_level: 0, has_waiver: 0, ilo: 0, istd: 0, approval_notes: '', wtd: 1, request_id: '', level: '' };

  IS_PEER_TO_PEER: any;
  ADDED_TO_PAYMENT_QUEUE: any;
  loan_approvals: any;
  queue_disbursement: any;
  pay_from_loan: any;
  states: any;
  lgas: any;
  sectors: any;
  occupations: any;
  edu_sectors: any;
  designations: any;
  loading = false;
  is_individual =true;
  constructor(
    private customerService: CustomerService,
    private DataService: DataService,
    public route: ActivatedRoute,
    public storageService: StorageService,
    public optionsService: OptionsserviceService,
    public loansService: LoansService,
    public operationsService: OperationsService,
    public dataService: DataService,
    public toastr: ToastrService, public router: Router) {
    this.currentUser = this.storageService.read<any>('currentUser');
    this.DataService.sendBackLoanToCaller.subscribe(res => { 
      this.loan = res.loan;
    })
    this.DataService.requestLoad.subscribe(res => {
      this.creating_contract = false;
      this.parentRouteId = res.request_id;
      this.getSummary();
    })
    this.DataService.refreshPage.subscribe(res => {
      this.getSummary();
    })
    // this.DataService.onRequestLoadingFromBackend.emit();
  }
  requestingData(event){
    this.DataService.requestingfordata.emit(event);
  }
  creatingContract() {
    this.creating_contract = true;
  }
  editingContract() {
    this.DataService.openContractModal.emit({ currentUser: this.currentUser, request_id: this.parentRouteId, loan: this.loan });
  }
  openContractModal() {
    this.DataService.openContractModal.emit({ currentUser: this.currentUser, request_id: this.parentRouteId, loan: this.loan });
  }
  ngOnInit() {
    this.dataService.getLoanFromTheDashboard.emit();
    this.getSummary();
    this.optionsService.getSec().subscribe(sectors => (this.sectors = sectors));
    this.optionsService.getOcc().subscribe(sectors => (this.occupations = sectors));
    this.optionsService.getDes().subscribe(sectors => (this.designations = sectors));
    this.optionsService.getEdu().subscribe(sectors => (this.edu_sectors = sectors));
    this.optionsService.getStates().subscribe(sectors => (this.states = sectors));
  }
  getSummary() {
    this.sub = this.route.params.subscribe(params => {
      this.parentRouteId = +params['id'];
      this.getLoan();
    });
  }
  getCusomer(people_id) {
    this.loansService.getLoanContractCustomerFromLoan(this.currentUser.token, people_id)
      .subscribe(data => { 
        this.customer = data.data;
        this.is_individual = data.is_individual;
        //this.states = data.data.states;
        this.lgas = data.data.lgas;
        this.loading = false;
      });
  }
  loadLGAs(event) {
    this.optionsService.getLGAs(this.currentUser.token, event).subscribe(lgas => this.lgas = lgas.lgas);
  }
  getLoan() {
    this.loading = true;
    // this.loansService.getLoanForCustomerSlim(this.currentUser.token, this.parentRouteId)
    //   .subscribe(data => {

    //     this.loading = false;
    //     this.loan = data.loan; 

        
    //   });
    this.getCusomer(this.parentRouteId);
  }
  openModal(section) {
    this.dataService.onOpenApplicationsModal.emit({ section: section, request_id: this.parentRouteId });
  }
  confirmReopenRequest() {
    //this.childModal = { location: 'confirm_reopen_request', data: this.loan };
  }
  openLoanSpider(loan) {
    //this.router.navigate(['analytics/' + request_id + '/spider']);
    if (loan.loan_status < '3') {
      this.router.navigate(['./applications/analytics/' + loan.request_id + '/spider']);
    } else {
      this.router.navigate(['./portfolio/analytics/' + loan.request_id + '/spider']);
    }

  }
  openUnderConstruction() {
    this.DataService.openUnderConstruction.emit({ endDate: '1561978800000' });
  }
  openProfile(request_id) {
    this.router.navigate(['./applications/profile/' + request_id]);
  }
  openGuarantors(request_id) {
    this.router.navigate(['./applications/guarantors/' + request_id]);
  }
  opentimeline(request_id) {
    this.router.navigate(['./applications/timeline/' + request_id]);
  }
  openAnalytics(request_id) {
    this.router.navigate(['./applications/analytics/' + request_id]);
  }
  openCreditCheck(request_id) {
    this.router.navigate(['./applications/creditcheck/' + request_id]);
  }
  openPreviousRequests(request_id) {
    this.router.navigate(['./applications/requests/' + request_id]);
  }
  openOfferLetter(request_id) {
    this.router.navigate(['./applications/offerletter/' + request_id]);
  }
  doingDisbursement(event) {

  }
  saveBio() {
    this.loading = true;
    this.customerService.updateCustomer(this.currentUser.token, this.parentRouteId, this.loan.people_id, { ...this.customer.profile, ...this.customer.home_address })
      .subscribe(data => {
        this.loading = false;
        this.getLoan();
      });
  }
  saveExpenses() {
    this.loading = true;
    this.customerService.updateCustomer(this.currentUser.token, this.parentRouteId, this.loan.people_id, {
      ...this.customer.expenses
    })
      .subscribe(data => {
        this.loading = false;
        this.getLoan();
      });
  }
  saveWork() {
    this.loading = true;
    this.customerService.updateCustomer(this.currentUser.token, this.parentRouteId, this.loan.people_id, {
      ...this.customer.work
    })
      .subscribe(data => {
        this.loading = false;
        this.getLoan();
      });
  }
  saveNok() {
    this.loading = true;
    this.customerService.updateCustomer(this.currentUser.token, this.parentRouteId, this.loan.people_id, {
      ...this.customer.next_of_kin,
    })
      .subscribe(data => {
        this.loading = false;
        this.getLoan();
      });
  }
  sendContract() {
    this.DataService.onOpenLoanChildModal.emit({ 'location': 'send_contract_mod', data: this.loan });
  }
  showIdCard(pic) {
    this.dataService.showIDCard.emit({ pic: pic });
  }
  showSuccess(message) {
    this.toastr.success(message, 'Success!');
  }

  showError(message) {
    this.toastr.error(message, 'Error');
  }
}
